module.exports = __webpack_public_path__ + "static/img/color.55c04d6f.png";